import React from 'react';
import { FormattedMessage } from 'react-intl';
import { orderBy } from 'lodash';
import { takeEvery, put, call } from 'redux-saga/effects';
import {
  addWorkspacesList,
  loadingWorkspace,
} from 'Workspace/Admin/store/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection) {
  yield put(loadingWorkspace(true));
  const workspaceWorkspacesList = yield call(connection.fetch.bind(connection), constants.RTM_WORKSPACE_LIST);
  if (workspaceWorkspacesList.type === constants.RTM_WORKSPACE_LIST_OK) {
    const workspaces = workspaceWorkspacesList.response.workspaces;
    yield put(addWorkspacesList(_getSortedWorkspaces(workspaces)));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspaceWorkspacesList} />,
    }));
  }
  yield put(loadingWorkspace(false));
}

const _getSortedWorkspaces = (workspaces) => orderBy(workspaces, (workspace) => workspace.name.replace(/\s/g, '').toLowerCase(), 'asc');

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_WORKSPACES_LIST, catchErrors, sendRequest, connection);
}
